// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bars16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bars': IconBars;
    }
}

/**
 * The icon component for the 'bars' icon
 */
export class IconBars extends IconSvg {
    public constructor() {
        super(bars16X16);
    }
}

registerIconSvg('icon-bars', IconBars);
export const iconBarsTag = 'nimble-icon-bars';
